module.exports = __webpack_public_path__ + "static/woman_set_1toddler.31f3bdfc.svg";